<!--
 * @Description: 付款
 * @Author: luzx
 * @Date: 2023-08-01 9:09:06
 * @LastEditors: hexy
 * @LastEditTime: 2025-01-22 11:38:04
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <div class="header_right" @click="showCardNav = !showCardNav">
        <div class="title">搜索</div>
        <div>
          <div :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }">
            <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
          </div>
        </div>
      </div>
      <div v-show="showCardNav" class="hr"></div>
      <el-collapse-transition>
        <div v-show="showCardNav">
          <div class="search">
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 90px; text-align: right">付款日期：</span>
              <el-date-picker v-model="searchDate" unlink-panels type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="dateChange"> </el-date-picker>
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 90px; text-align: right">付款方式：</span>
              <el-select v-model="tableParam.paymentMethodId" style="width: 200px" clearable placeholder="请选择">
                <el-option v-for="(item, index) in shoukuanList" :key="index" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 120px; text-align: right">付款行及金融工具:</span>
              <el-input v-model="tableParam.authBank" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 90px; text-align: right">供应商单位:</span>
              <el-input v-model="tableParam.supplier" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 90px; text-align: right">支付合同主体:</span>
              <!-- <el-input v-model="tableParam.payContractSubject" style="width: 200px" clearable placeholder="请输入" /> -->
              <el-select v-model="tableParam.payContractSubjectNameList" style="width: 280px" multiple filterable placeholder="请选择">
                <el-option v-for="(item, index) in mainList" :key="index" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 90px; text-align: right">票号：</span>
              <el-input v-model="tableParam.billNumber" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">支付金额：</span>
              <el-input v-model="tableParam.paymentMoneyStart" style="width: 200px" clearable placeholder="请输入" />至<el-input v-model="tableParam.paymentMoneyEnd" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-bottom: 10px">
              <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableDataex()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
            </span>
          </div>
        </div>
      </el-collapse-transition>
      <div class="hr"></div>
      <el-main style="display: flex">
        <div>
          <!-- <div class="card scroll"> -->
          <div class="card">
            <div class="card_nav">
              <div style="display: flex; align-items: center">
                <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="small" class="bottom_all" style="margin-left: 0" @click="addcard"> 添加 </el-button>
                <el-button size="small" class="bottom_one" style="margin-left: 10px" @click="exportDialog=true"> 导入 </el-button>
                <!-- <el-button size="small" class="bottom_all" style="margin-left: 10px" @click="costMoneyInit"> 付款单位管理</el-button>
                     <el-button  size="small" class="bottom_all" style="margin-left: 10px" :loading="loadingSaller" @click="loadingSaller = true; sallerSure()"> 销售确认</el-button> -->
                <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'SHANCHU') !== -1" size="small" class="bottom_two" @click="delHandler"> 删除 </el-button>
                <div style="margin-left: 10px; color: red; font-weight: bold"><span style="">合计金额：</span>{{ tableData[0] ? (tableData[0].totalMoney ? numFormat(tableData[0].totalMoney) : 0) : 0 }} 元</div>
              </div>
              <div>
                <el-button size="medium" class="bottom_all" style="margin-left: 12px" @click="load()">导 出</el-button>
              </div>
            </div>
            <!-- { background: '#f3f6f9' } -->
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table
                :header-cell-style="setTitle"
                :cell-style="{ borderRight: 'none' }"
                border
                stripe
                style="width: 100%"
                :data="tableData"
                tooltip-effect="dark"
                :height="screenHeight - 520"
                :span-method="objectSpanMethod"
                @selection-change="handleSelectionChange"
              >
                <el-table-column align="center" type="selection"></el-table-column>
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :min-width="item.width" :fixed="item.label == '操作' ? 'right' : false">
                    <template slot-scope="scope">
                      <span v-if="item.label == '状态'">
                        <span v-if="scope.row.dataStatus == 0" style="color: #969799">未开票</span>
                        <span v-if="scope.row.dataStatus == 1" style="color: #00a754">已开票</span>
                      </span>
                      <span v-else-if="item.label == '集团内'">
                        <span v-if="scope.row.whetherGroup == 0" style="color: #969799">否</span>
                        <span v-else-if="scope.row.whetherGroup == 1" style="color: #00a754">是</span>
                      </span>
                      <span v-else-if="item.label == '支付金额（元）'">
                        <span  >{{numFormat(scope.row.paymentMoney)}}</span>
                      </span>
                      <span v-else-if="item.label == '本次付款金额（元）'">
                        <span  >{{numFormat(scope.row.currentPayMoney)}}</span>
                      </span>
                      <span v-else-if="item.label == '流程'">
                        <span v-if="scope.row.flowPath == 0" style="color: #969799">流程未走完</span>
                        <span v-if="scope.row.flowPath == 1" style="color: #00a754">流程已走完</span>
                      </span>
                      <span v-else-if="item.label == '是否认领'">
                        <span style="color: #969799">{{ ["流水待认领", "流水未认领完", "流水已认领，流程中", "流水已认领", "已完结"][scope.row.claimStatus] }}</span>
                      </span>
                      <div v-else-if="item.label == '操作'">
                        <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'XIUGAI') !== -1" class="bottom_one" size="mini" @click="lookcard(scope.row.id)"> 修改 </el-button>
                      </div>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableDataex()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableDataex">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- <diaLog1 :dialog="dialog1" :low="low" @reset="reset" @submit="submit"></diaLog1> -->
    <!-- 除抵款以外的添加 -->
    <el-dialog :title="titleName" :visible.sync="dialog" width="1000px" :close-on-click-modal="false">
      <div>
        <el-form ref="formDate" :rules="rules" :model="formDate" :inline="true" label-width="160px">
          <el-form-item label="付款日期：" prop="paymentTime">
            <el-date-picker v-model="formDate.paymentTime" type="date" style="width: 300px" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
          </el-form-item>
          <el-form-item label="付款方式：" prop="paymentMethodId">
            <el-select
              ref="shoukuanList"
              v-model="formDate.paymentMethodId"
              style="width: 300px"
              placeholder="请选择"
              @change="
                changestatus(),
                  $nextTick(() => {
                    formDate.paymentMethod = $refs.shoukuanList.selectedLabel;
                  })
              "
            >
              <el-option v-for="(item, index) in shoukuanList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付金额（元）：" prop="paymentMoney">
            <el-input v-model="formDate.paymentMoney" style="width: 300px" disabled clearable placeholder="请输入" />
          </el-form-item>
          <div style="margin-bottom: 20px">
            <el-button v-if="isAddOffset" type="primary" @click="addCardOffset()">添 加</el-button>
            <el-button v-else type="primary" @click="addCollectClaim()">添 加</el-button>
            <el-button type="primary" @click="downLoadHandler">下载模版</el-button>
            <el-button type="primary" @click="intLoad()">导入模版</el-button>
          </div>
          <div style="margin-bottom: 20px">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="collectClaimList" tooltip-effect="dark">
              <el-table-column label="付款来源" align="center" width="120">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.paymentSource" style="width: 100px" filterable placeholder="请选择" @change="changstatus1(scope.$index, scope.row)">
                    <el-option v-for="(item, index) in paymentTypes" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="票号" align="center" width="300">
                <template slot-scope="scope">
                  <!-- <el-input v-model="scope.row.billNumber" type="text" style="width: 280px" clearable
                                        placeholder="请输入" 
                                        /> -->
                  <el-select
                    ref="supplier"
                    v-model="scope.row.billNumber"
                    style="width: 260px"
                    filterable
                    placeholder="请选择"
                    :disabled="scope.row.paymentSource == '现金' || scope.row.paymentSource == ''||scope.row.paymentSource == '抵款' "
                    @change="billNumberChange(scope.$index, scope.row)"
                  >
                    <el-option v-for="(item, index) in billNumberList" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="供应商类别" align="center" width="200">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.supplierType" style="width: 140px" filterable placeholder="请选择" @change="changstatus2(scope.$index, scope.row)">
                    <el-option v-for="(item, index) in supplierCategoryList" :key="index" :label="item.itemName" :value="item.itemName"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="供应商名称" align="center" width="360">
                <template slot-scope="scope">
                  <!-- <el-select ref="supplier" v-model="scope.row.supplier" style="width: 300px" filterable
                                        placeholder="请选择" @change="changstatus3(scope.$index, scope.row);">
                                        <el-option v-for="(item, index) in supplierList" :key="index" :label="item.name"
                                            :value="item.name"></el-option>
                                    </el-select> -->
                  <el-select ref="supplier" v-model="scope.row.supplier" filterable allow-create default-first-option style="width: 300px" placeholder="请选择" @change="structuralPartsCheckFun(scope.$index, scope.row)">
                    <el-option v-for="(item, index) in supplierList" :key="index" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="支付合同主体" align="center" width="300">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.payContractSubject" style="width: 280px" filterable placeholder="请选择"
                  :disabled="scope.row.paymentSource == '抵款' "
                  @change="changstatus4(scope.$index, scope.row)">
                    <el-option v-for="(item, index) in mainList" :key="index" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="本次付款金额（元）" align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.currentPayMoney" type="number" style="width: 100px" clearable placeholder="请输入" />
                </template>
              </el-table-column>
              <el-table-column label="票据来源" align="center" width="auto">
                <template slot-scope="scope">
                  <span>{{ scope.row.billSource }}</span>
                </template>
              </el-table-column>
              <el-table-column label="所属主体" align="center" width="auto">
                <template slot-scope="scope">
                  <span>{{ scope.row.subjectCompany }}</span>
                </template>
              </el-table-column>
              <el-table-column label="票面金额" align="center" width="auto">
                <template slot-scope="scope">
                  <span>{{ scope.row.billMoney }}</span>
                </template>
              </el-table-column>
              <el-table-column label="付款行及金融工具" align="center" width="200">
                <template slot-scope="scope">
                  <span v-if="scope.row.paymentSource != '现金'">{{ scope.row.authBank }}</span>
                  <el-select v-if="scope.row.paymentSource == '现金'" ref="supplier" v-model="scope.row.authBank" style="width: 180px" filterable placeholder="请选择" @change="changstatus5(scope.$index, scope.row)">
                    <el-option v-for="(item, index) in shoukuanandmonList1" :key="index" :label="item.itemName" :value="item.itemName"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="票据类型" align="center" width="auto">
                <template slot-scope="scope">
                  <span>{{ scope.row.billTypeName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="承兑人名称" align="center" width="auto">
                <template slot-scope="scope">
                  <span>{{ scope.row.acceptor }}</span>
                </template>
              </el-table-column>
              <el-table-column label="出票人户名" align="center" width="auto">
                <template slot-scope="scope">
                  <span>{{ scope.row.drawer }}</span>
                </template>
              </el-table-column>
              <el-table-column label="收款人户名" align="center" width="auto">
                <template slot-scope="scope">
                  <span>{{ scope.row.receiver }}</span>
                </template>
              </el-table-column>
              <el-table-column label="出票日期" align="center" width="auto">
                <template slot-scope="scope">
                  <span>{{ scope.row.issueDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="到期日期" align="center" width="auto">
                <template slot-scope="scope">
                  <span>{{ scope.row.dueDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="120" fixed="right">
                <template slot-scope="scope">
                  <el-button size="mini" class="bottom_two" @click="delItem1(scope.$index)">
                    <i class="icon iconfont" style="font-size: 12px"></i>
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-form-item label="备注1：">
            <el-input v-model="formDate.remark1" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="备注2：">
            <el-input v-model="formDate.remark2" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="备注3：">
            <el-input v-model="formDate.remark3" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="备注4：">
            <el-input v-model="formDate.remark4" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="addcardSure('formDate')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 抵款添加 -->
    <el-dialog :title="titleName" :visible.sync="offsetDialog" width="1000px" :close-on-click-modal="false">
      <div class="search">
        <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
          <span style="margin-right: 12px; display: inline-block; width: 90px; text-align: right">收款编码：</span>
          <el-input v-model="offsetParam.id" style="width: 200px" clearable placeholder="请输入" />
        </span>
        <!-- <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
          <span style="margin-right: 12px; display: inline-block; width: 90px; text-align: right">合同单位</span>
          <el-input v-model="offsetParam.contractUnit" style="width: 200px" clearable placeholder="请输入" />
        </span> -->
        <span style="display: inline-block; margin-bottom: 10px">
          <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(offsetParam.page = 1), getOffset()">查 询</el-button>
          <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="initOffset()">重 置</el-button>
        </span>
      </div>
      <div>
        <el-table  :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="offsetTableData" tooltip-effect="dark" :height="screenHeight - 520" @selection-change="handleSelectionChangeOff" >
        <el-table-column align="center" type="selection"></el-table-column>
        <template v-for="(item, index2) in offsetTable">
          <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :min-width="item.width" :fixed="item.label == '操作' ? 'right' : false">
            <template slot-scope="scope">
              <span>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
      </div>
      <div class="top_page_totle">总共{{ offsetTotal }}条
        <el-pagination  :current-page.sync="offsetParam.page"  :page-size="offsetParam.pageSize"  :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"  layout="prev,pager,sizes,next,jumper"  :total="offsetTotal"  @size-change="sizeChange"  @current-change="getOffset()"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="offsetDialog = false">取 消</el-button>
        <el-button class="bottom_all" @click="saveOffset">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入 -->
    <el-dialog v-dialogDrag :visible.sync="exportDialog" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">导入付款信息</span>
      <div v-loading="loading" element-loading-text="数据解析中..." element-loading-background="rgba(0, 0, 0, 0.8)" class="dialoginfo" style="text-align: center">
        <el-upload class="upload-demo" :on-success="fileSuccess" :before-upload="filebefore" :show-file-list="false" drag action="/icps/system/sign/dataCollection/payment/importPayList" name="file" :headers="upheader">
          <i slot="trigger" class="el-icon-upload"></i>
          <div slot="trigger" class="el-upload__text">
            将文件拖到此处，或
            <em>点击选取文件</em>
          </div>
        </el-upload>
        <div style="padding-top: 10px">
          <el-button class="bottom_all" style="margin-left: 0" @click="importSubmit()">下载模板</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="exportDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 导入 -->
    <el-dialog title="导入模版" :visible.sync="dialog3" width="500px" :close-on-click-modal="false">
      <div style="text-align: center">
        <el-upload
          class="upload-demo"
          drag
          action="/icps/system/sign/dataCollection/payment/detail/importPayDetail"
          :headers="{ 'access-token': token }"
          :on-change="fileChange"
          :before-upload="beforeUpload"
          :on-remove="handleRemove"
          :on-success="success"
          :before-remove="beforeRemove"
          multiple
          :file-list="fileList"
          :limit="1"
          accept=".xlsx"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">请上传.xlsx文件</div>
        </el-upload>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="dialog3 = false">关 闭</el-button>
                <el-button type="primary" @click="sendSrueSaller">确 定</el-button>
            </span> -->
    </el-dialog>
  </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { formatTreeData } from "@/utils/utils";
import { querysupplierPage } from "@/api/GHnumber/supplier.js";
// import { getDicsType } from "@/api/common.js";
// import { getUserInfo } from "@/utils/auth"
import {
  queryPage,
  Download,
  get_list_by_type,
  selectByBillNumber,
  selectTicketList,
  queryInvoicedAmount,
  saveOrUpdate,
  saveOrUpdatecollectMoney,
  deletePayUnit,
  get_detail_code,
  deleteNotes,
  queryEngineering,
  queryCollectClaimList,
  updateCollectMoneyClaim,
  queryDefaultSallers,
} from "@/api/GHnumber/payment.js";
import { queryPageTicket,queryPageTicketPay} from "@/api/internetSales/otherPayment.js";
import { post } from "@/api/table.js";
import { getToken, getUserId } from "@/utils/auth";
export default {
  mixins: [mixin],
  data() {
    return {
      token: getToken(),
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      DownloadURL: Download,
      batchUpdateOrDelete: deleteNotes,
      /*表格数据*/
      table: [
        { label: "付款编号", width: "120", prop: "id", status: true },
        { label: "付款日期", width: "120", prop: "paymentTime", status: true },
        { label: "付款方式", width: "140", prop: "paymentMethod", status: true },
        // { label: "供应商名称", width: "140", prop: "supplier", status: true },
        { label: "支付金额（元）", width: "140", prop: "paymentMoney", status: true },
        { label: "付款来源", width: "120", prop: "paymentSource", status: true },
        { label: "票号", width: "300", prop: "billNumber", status: true },
        { label: "票据来源", width: "300", prop: "billSource", status: true },
        { label: "供应商类别", width: "120", prop: "supplierType", status: true },
        { label: "供应商名称", width: "120", prop: "supplier", status: true },
        { label: "支付合同主体", width: "120", prop: "payContractSubject", status: true },
        // { label: "合同单位", width: "300", prop: "collectMoney", status: true },
        { label: "本次付款金额（元）", width: "300", prop: "currentPayMoney", status: true },
        { label: "票面金额（元）", width: "300", prop: "billMoney", status: true },
        { label: "付款行及金融工具", width: "120", prop: "authBank", status: true },
        { label: "所属主体", width: "120", prop: "subjectCompany", status: true },
        { label: "票据类型", width: "180", prop: "billTypeName", status: true },
        { label: "承兑人名称", width: "120", prop: "acceptor", status: true },
        { label: "出票人户名", width: "120", prop: "drawer", status: true },
        { label: "收款人户名", width: "240", prop: "receiver", status: true },
        { label: "出票日期", width: "240", prop: "issueDate", status: true },
        { label: "到期日期", width: "240", prop: "dueDate", status: true },
        { label: "备注1", width: "240", prop: "remark1", status: true },
        { label: "备注2", width: "240", prop: "remark2", status: true },
        { label: "备注3", width: "240", prop: "remark3", status: true },
        { label: "备注4", width: "240", prop: "remark4", status: true },
        { label: "操作", width: "120", prop: "", status: true },
      ],
      offsetParam:{
        page: 1,
        pageSize: 10,
        collectMoneyMethodId: "333424134828724224",
        id:"",
        contractUnit:"",
      },
      offsetTableData:[],
      selectList:[],
      offsetTotal:"",
      offsetTable:[
        { label: "收款编码", width: "auto", prop: "id", status: true },
        { label: "年月", width: "auto", prop: "collectMoneyMouth", status: true },
        { label: "日期", width: "auto", prop: "collectMoneyData", status: true },
        { label: "合同签订主体", width: "auto", prop: "collaborationUnit", status: true },
        { label: "合同单位", width: "auto", prop: "contractUnit", status: true },
        // { label: "工程名称", width: "auto", prop: "enginnerrName", status: true },
        { label: "认领金额（元）", width: "auto", prop: "collectMoney", status: true },
        { label: "剩余收款金额", width: "auto", prop: "remainMoney", status: true },
        // { label: "剩余抵扣金额", width: "auto", prop: "remainPay", status: true },
      ],
      pagesType: 0,
      dialog: false,
      offsetDialog: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      exportDialog:false,
      loading: false,
      upheader: {
        "access-token": getToken(),
        "user-id": getUserId(),
      },
      disabled: false,
      modifyType: false,
      fileList: [],
      low: {},
      rules: {
        paymentTime: [{ required: true, message: "请选择付款日期", trigger: "change" }],
        paymentMethodId: [{ required: true, message: "请选择付款方式", trigger: "change" }],
      },
      engineeringNameList: [], //工程名称列表
      invoicedAmount: "", //
      files: [],
      claimList: [
        { name: "流水待认领", id: 0 },
        { name: "流水未认领完", id: 1 },
        { name: "流水已认领，流程中", id: 2 },
        { name: "流水已认领", id: 3 },
        { name: "已完结", id: 4 },
      ], //是否认领列表
      mainList: [], //主体列表

      costMoneyInitData: [],
      payerUnitParams: {
        page: 1,
        pageSize: 10,
        payerUntiName: "",
      },
      totalpayerUnit: 0,
      tablepayerUnit: [],
      addPayerUnit: {
        payerUntiName: "",
        whetherGroup: 0,
      },
      payerUnitNoPage: [],
      formDate: {
        paymentTime: new Date(),
        paymentMethodId: "",
        paymentMoney: 0,
        remark1: "",
        remark2: "",
        remark3: "",
        remark4: "",
      },
      list: [],
      shoukuanList: [],
      shoukuanandmonList: [],
      shoukuanandmonList1: [],
      shoukuanandmonList2: [],
      piaojuList: [],
      recourseTransferList: [
        { name: "无追可转", id: "1" },
        { name: "无追不可转", id: "2" },
        { name: "可追可转", id: "3" },
        { name: "可追不可转", id: "4" },
      ],
      contractProcessList: ["合同已收", "流程已收"],
      collectionMethodList: [
        { name: "合同约定", id: "1" },
        { name: "流程审核", id: "2" },
      ],
      editFlag: false,
      options: [],
      isMust: true,
      titleName: "添加",
      collectClaimList: [], //认领列表
      renlingId: "",
      sallerList: [],
      treeArry: [],
      organizationList: [],
      userList: [],
      userNameList: [],
      sendFlag: true,
      loadingSaller: false,
      paymentTypes: [
        { name: "票据", id: "票据" },
        { name: "现金", id: "现金" },
        { name: "抵款", id: "抵款" },
      ],
      searchDate: "",
      supplierList: [],
      supplierCategoryList: [],
      tableDataCopy: [],
      billNumberList: [],
      isAddOffset:false,
    };
  },
  created() {
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { ...this.tableParam, paymentMethodId: "", supplier: "", startTime: "", endTime: "", billNumber: "", payContractSubject: "", authBank: "", paymentMoneyEnd: "", paymentMoneyStart: "",payContractSubjectNameList:[], };
    this.gettableDataex();
    let params = {
      page: 1,
      pageSize: 99999,
      enable: 1,
    };
    querysupplierPage(params).then(res => {
      this.supplierList = res.data.data;
      this.get_detail_code();
    });
    selectTicketList().then(res => {
      var arr = [...new Set([...res.data])];
      var arr2 = arr.filter(e => {
        return e && e.trim();
      });
      // arr2.forEach((e, i) => {
      //     .push(
      //         { id: i, name: e }
      //     )
      // })
      this.billNumberList = arr2;
    });
    this.get_list_by_type();
  },
  mounted() {
    // if (this.ButtonList.findIndex(res => (res.buttonValue == 'XIUGAI')) == -1 && this.ButtonList.findIndex(res => (res.buttonValue == 'RENLING')) == -1) {
    //     this.table[33].status = false
    // } else {
    //     this.table[33].status = true
    // }
  },
  methods: {
    downLoadHandler() {
      window.open("https://lvshe.huashijc.com/file/group1/M00/0B/9A/ChQACmTRpp6AMXO8AAAkF_dvW9o22.xlsx");
    },
    importSubmit(){
      window.open("https://lvshe.huashijc.com/file/group1/M00/0D/44/ChQACmUSgQuAd2C2AAFvlv1PNnM12.xlsx");
    },
    /*导入数据*/
    filebefore(file) {
      this.loading = true;
      const isJPG = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isJPG) {
        this.$message.error("数据上传必须是 xlsx 格式!");
        this.loading = false;
      }
      return isJPG;
    },
    fileSuccess(res) {
      this.loading = false;
      if (res.code == 1001) {
        this.$message.error(res.codeMsg);
        // this.$message({
        //   dangerouslyUseHTMLString: true,
        //   message: `本次导入数据成功！！！`,
        //   type: "success",
        // });
        this.exportDialog = false
        this.gettableDataex();
      } else {
        this.$message.error(res.codeMsg);
      }
    },
    intLoad() {
      this.dialog3 = true;
      this.fileList = [];
    },
    billNumberChange(i, v) {
      console.log(i);
      console.log(v);
      let data = [v.billNumber];
      selectByBillNumber(data).then(res => {
        this.collectClaimList[i] = { ...this.collectClaimList[i], ...res.data[0], paymentSource: "票据" };
        this.$set(this.collectClaimList, i, this.collectClaimList[i]);
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    beforeRemove(file, fileList) {
      console.log(file, fileList);
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    beforeUpload(file) {
      console.log("begor--", file);
    },
    fileChange(file, fileList) {
      console.log("change--", file, fileList);
    },
    /* 文件上传成功的回调 */
    success(response) {
      this.collectClaimList = [...this.collectClaimList, ...response.data];
      this.dialog3 = false;
    },
    dateChange(e) {
      console.log(e);
      if (e) {
        this.tableParam.startTime = e[0];
        this.tableParam.endTime = e[1];
      } else {
        this.tableParam.startTime = "";
        this.tableParam.endTime = "";
      }
    },
    structuralPartsCheckFun(e) {
      let item = this.supplierList.find(v => v.name == this.collectClaimList[e].supplier);
      console.log(item);
      // var chooseArr = this.supplierList.filter(m => {
      //     if (m.name == row.supplier) {
      //         return true
      //     }
      // })
      // console.log(row.supplier)
      // console.log(chooseArr)
      // this.collectClaimList[e].supplierId = chooseArr[0].id
      // this.$set(this.collectClaimList, e, this.collectClaimList[e])
      // this.formDate.contractProcess = "";

      // if (item) {
      //     this.formDate.strengthGradeId = JSON.parse(item.strengthGrade)[0].id;
      //     if (item.performanceGrade) {
      //         this.formDate.performanceGradeIdList = JSON.parse(item.performanceGrade).map(v => v.id);
      //     }
      //     if (item.meterialRequirements) {
      //         this.formDate.meterialRequirementsIdList = JSON.parse(item.meterialRequirements).map(v => v.id);
      //     }
      //     if (item.specialRequirements) {
      //         this.formDate.specialRequirementsIdList = JSON.parse(item.specialRequirements).map(v => v.id);
      //     }
      //     if (item.otherRequirements) {
      //         this.formDate.otherRequirementsIdList = JSON.parse(item.otherRequirements).map(v => v.id);
      //     }
      //     if (item.admixtureRequirements) {
      //         this.formDate.admixtureRequirementsIdList = JSON.parse(item.admixtureRequirements).map(v => v.id);
      //     }
      // }
    },
    /**
     * @Description: 获取所有组织和用户、格式化tree结构
     * @Param:
     * @Author: wangwangwang
     */
    initOrganization() {
      /* 
              把计算缓慢的数据暂时隐藏
            */
      // const { state } = this.$store;
      // if (!state.approvePerson.orgList || !state.approvePerson.userList) {
      //   console.log("---------user----------");
      //   const orgPromise = this.$store.dispatch("approvePerson/getorg");
      //   const userPromise = this.$store.dispatch("approvePerson/getuser");
      //   this.loading = true;
      //   Promise.all([orgPromise, userPromise])
      //     .then(([orgres, userres]) => {
      //       this.formatDataSource(orgres, userres);
      //     })
      //     .catch(e => console.log(e));
      // } else {
      //   this.formatDataSource(state.approvePerson.orgList, state.approvePerson.userList);
      // }
      const orgPromise = localStorage.getItem("setPersonOrg") ? JSON.parse(localStorage.getItem("setPersonOrg")) : this.$store.dispatch("approvePerson/getorg");
      const userPromise = localStorage.getItem("setPersonUser") ? JSON.parse(localStorage.getItem("setPersonUser")) : this.$store.dispatch("approvePerson/getuser");
      this.loading = true;
      Promise.all([orgPromise, userPromise])
        .then(([orgres, userres]) => {
          console.log("orgres", orgres);
          console.log("userres", userres);
          this.formatDataSource(orgres, userres);
        })
        .catch(e => console.log(e));
    },
    formatDataSource(orgList, userList) {
      orgList.forEach(v => {
        v.type = 2;
      });
      this.organizationList = formatTreeData(orgList, "id", "parentId", "children", "parent_id");
      if (!userList) {
        userList = [];
      }
      userList.forEach(v => {
        v.type = 1;
      });
      const newArry = userList.map(item => ({
        ...item,
        parentId: item.organizationId,
      }));
      this.userList = userList;
      /* 
              把计算缓慢的数据暂时隐藏
            */
      let storageUserList = []; //缓存的用户数据
      this.$forage.getItem("orgListData").then(val => {
        storageUserList = val;
      });
      console.log(storageUserList);
      if (storageUserList?.length > 0) {
        this.allData = storageUserList;
        this.treeArry = storageUserList;
        console.log("this.treeArry", this.treeArry);
      } else {
        let arr = formatTreeData(orgList.concat(newArry), "id", "parentId", "children", "parent_id");
        this.allData = arr;
        this.treeArry = arr;
        this.$forage.setItem("orgListData", arr).then(val => {
          console.log(val);
        });
        console.log("this.treeArry", this.treeArry);
      }
      // this.treeArry = formatTreeData(
      //   orgList.concat(newArry),
      //   "id",
      //   "parentId",
      //   "children",
      //   "parent_id"
      // );
      // this.allData = formatTreeData(
      //   orgList.concat(newArry),
      //   "id",
      //   "parentId",
      //   "children",
      //   "parent_id"
      // );
      this.loading = false;
    },
    delItem(i) {
      this.sallerList.splice(i, 1);
      console.log(this.sallerList);
    },
    delItem1(i) {
      console.log(i);
      this.collectClaimList.splice(i, 1);
    },
    addsallerList() {
      let arr = this.$refs["cascader"].getCheckedNodes();
      arr.forEach(e => {
        if (e.children.length == 0) {
          this.sallerList.push({ saller: e.label, sallerId: e.value });
        }
      });
      const map = new Map();
      const newList3 = this.sallerList.filter(v => !map.has(v.sallerId) && map.set(v.sallerId, 1));
      this.sallerList = newList3;
    },
    sendSrueSaller() {
      this.dialog3 = false;
    },
    userChooseChange(e) {
      console.log(e);
    },
    setTitle(row) {
      // console.log(row);
      const columnIndex = row.columnIndex;
      if (
        columnIndex == 5 ||
        columnIndex == 6 ||
        columnIndex == 7 ||
        columnIndex == 8 ||
        columnIndex == 9 ||
        columnIndex == 10 ||
        columnIndex == 11 ||
        columnIndex == 12 ||
        columnIndex == 13 ||
        columnIndex == 14 ||
        columnIndex == 15 ||
        columnIndex == 16 ||
        columnIndex == 17 ||
        columnIndex == 18 ||
        columnIndex == 19 ||
        columnIndex == 20
      ) {
        return "background: #fffd97;";
      } else {
        return "background: #f3f6f9;";
      }
    },
    changestatus() {
      console.log(this.formDate.collectMoneyMethodId);
      console.log(this.formDate.paymentMethodId);
      if(this.formDate.paymentMethodId == "333424134828724224"){
        this.isAddOffset = true
      }else{
        this.isAddOffset = false
      }
    },
    numFormat(num) {
      if (num === null || num === undefined || num === '') {
        return 0;
      }
      var res = num.toString().replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ",";
        });
      });
      return res;
    },
    numFormatOff(num) {
      var res = num.replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ",";
        });
      });
      return res;
    },
    initaddPayer() {
      this.addPayerUnit = this.$options.data().addPayerUnit;
    },
    addPayerUnitSure() {
      saveOrUpdate(this.addPayerUnit).then(res => {
        if (res.code == 1001) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.initaddPayer();
          this.dialog2 = false;
        }
      });
    },
    delPayerUnit(row) {
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          deletePayUnit({ id: row.id }).then(res => {
            if (res.code == 1001) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => {});
    },
    /*获取列表*/
    async gettableDataex() {
      this.tableLoading = true;
      await post(this.queryPage, this.tableParam).then(res => {
        if (res.code === 1001) {
          this.tableLoading = false;
          this.total = res.data.totalRows;
          this.tableData = res.data.data;
          this.tableDataCopy = this.copy(res.data.data);
          this.reChange();
          this.copyDataSource = JSON.parse(JSON.stringify(res.data.data));
        }
      });
    },
    /*获取付款单位列表*/
    // async getpayerUnitManage() {
    //     this.tableLoading = true
    //     await post(this.queryPage1, this.payerUnitParams).then(res => {
    //         if (res.code === 1001) {
    //             this.tableLoading = false;
    //             this.totalpayerUnit = res.data.totalRows;
    //             this.tablepayerUnit = res.data.data;
    //         }
    //     });
    // },
    /* 获取主体 */
    get_list_by_type() {
      get_list_by_type({ typeId: "19da56b9e85648059e3cf1e7da497da4" }).then(res => {
        if (res.code == 1001) {
          this.mainList = res.data;
        }
      });
    },
    /* 获取字典 */
    get_detail_code() {
      //
      get_detail_code({ codes: "SHOUKUANXINGSHI,SHOUKUANHANG1,SHOUKUANHANG4,PIAOJULEIXING,ICPS_FinancialSupplierCategory" }).then(res => {
        if (res.code == 1001) {
          console.log(res.data);
          this.shoukuanList = res.data["SHOUKUANXINGSHI"].items;
          this.shoukuanandmonList1 = res.data["SHOUKUANHANG1"].items;
          this.shoukuanandmonList = res.data["SHOUKUANHANG1"].items;
          this.shoukuanandmonList2 = res.data["SHOUKUANHANG4"].items;
          this.piaojuList = res.data["PIAOJULEIXING"].items;
          this.supplierCategoryList = res.data["ICPS_FinancialSupplierCategory"].items;
          this.shoukuanandmonList1.forEach(e => {
            e.name = e.itemName;
            this.supplierList.push(e);
          });
        }
      });
    },
    reChange() {
      let arr = [];
      this.tableData.forEach(e => {
        if (e.list.length > 0) {
          let length = e.list.length;
          e.list.forEach((m, n) => {
            m.childId = this.copy(m.id);
            m.id = e.id;
            if (n === 0) {
              arr.push({ ...e, ...m, rowspan: length, colspan: 1 });
            } else {
              arr.push({ ...e, ...m, rowspan: 0, colspan: 0 });
            }
          });
        } else {
          arr.push({ ...e, rowspan: 1, colspan: 1 });
        }
      });
      this.tableData = arr;
      console.log("this.tableData----------------------", this.tableData);
    },
    changePayUnit() {
      var arrChoose = this.payerUnitNoPage.filter(e => {
        if (e.id == this.formDate.payUnitId) {
          return true;
        }
      });
      this.formDate.acceptor = arrChoose[0].payerUntiName;
      this.formDate.drawerAccount = arrChoose[0].payerUntiName;
      this.formDate.endorser = arrChoose[0].payerUntiName;
      this.formDate.whetherGroup = arrChoose[0].whetherGroup;
    },
    changeCollaborat() {
      var arrChoose = this.mainList.filter(e => {
        if (e.id == this.formDate.supplierId) {
          return true;
        }
      });
      this.formDate.supplier = arrChoose[0].name;
    },
    addcardSure(formName) {
      this.formDate.list = this.collectClaimList;
      console.log(this.collectClaimList);
      var time = new Date(this.formDate.paymentTime);
      this.formDate.paymentTime = time.Format("yyyy-MM-dd");
      // console.log(this.formDate);
      var isSave = false
      // 使用一个对象来存储每个 collectMoneyId 对应的 currentPayMoney 的总和
      let idSums = {};
      // 计算每个 id 对应的 currentPayMoney 的总和
      this.collectClaimList.forEach(item => {
          if (!idSums[item.collectMoneyId]) {
              idSums[item.collectMoneyId] = 0;
          }
          idSums[item.collectMoneyId] +=item.currentPayMoney*1;
          // idSums[item.collectMoneyId] +=parseInt(item.currentPayMoney);
          if (idSums[item.collectMoneyId] >= (item.claimMoney ? parseInt(item.claimMoney) : 0)) {
              isSave = true; // 只有当有一条数据不满足条件时才将 isSave 设置为 false
          }
          // isSave = (idSums[item.collectMoneyId]) >= (item.claimMoney?item.claimMoney*1: 0);
      });
      console.log(idSums)
      console.log(isSave)
      if(isSave && this.formDate.paymentSource=="抵款"){
        this.$message({
         message: "付款总和超过认领金额！",
         type:"warning"
        })
        return
      }else{
        this.$refs[formName].validate(valid => {
        if (valid) {
          saveOrUpdatecollectMoney(this.formDate).then(res => {
            if (res.code == 1001) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
            }
            this.gettableDataex();
            this.dialog = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      }

      // var editFlag = false
      // if(!editFlag){
      //     return;
      // }
      
    },
    queryEngineering() {
      queryEngineering().then(res => {
        this.engineeringNameList = res.data;
      });
    },
    queryInvoicedAmount(id) {
      queryInvoicedAmount({ engId: id }).then(res => {
        this.invoicedAmount = res.data;
      });
    },
    /**
     * @Description: 删除附件
     * @Param:
     * @Author: wangwangwang
     */
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess(data) {
      this.files.push(data);
    },
    addCollectClaim() {
      let item = {
        paymentSource: "", //工程id
        billNumber: "", //工程名
        supplierTypeId: "", //认领金额
        supplierType: "", //认领金额
        supplierId: "", //认领金额
        supplier: "", //认领金额
        payContractSubjectId: "", //合同签订主体d
        payContractSubject: "", //合同签订主体
        currentPayMoney: "",
      };
      this.collectClaimList.push(item);
    },
    addOtherCard(row) {
      console.log(row);
      this.formDate = row;
      this.renlingId = row.id;
      queryCollectClaimList({ id: row.id }).then(res => {
        if (res.code == 1001) {
          this.collectClaimList = res.data;
        }
      });
      this.dialog4 = true;
    },
    addcard() {
      this.formDate = this.$options.data().formDate;
      this.collectClaimList = [];
      this.titleName = "添加";
      this.dialog = true;
      this.$nextTick(() => {
        this.$refs["formDate"].clearValidate();
      });
    },
    getOffset(){
      queryPageTicket(this.offsetParam).then(res => {
        if (res.code == 1001) {
          res.data.data.forEach(item => {
            if( item.collectMoneyClaimList.length >0) {
              item.collaborationUnit = item.collectMoneyClaimList[0].collaborationUnit
              item.payContractSubject = item.collectMoneyClaimList[0].collaborationUnit
              item.payContractSubjectId = item.collectMoneyClaimList[0].collaborationUnitId
              item.contractUnit = item.collectMoneyClaimList[0].contractUnit
              item.paymentSource = "抵款"
            }
           
          })
          this.offsetTableData = res.data.data
          this.offsetTotal = res.data.totalRows
          
          queryPageTicketPay({payeeTypeId:"333424134828724224",page:1,pageSize:9999,id:this.offsetParam.id,customerUnit:this.offsetParam.contractUnit}).then(res2 => {
            if(res2.code == 1001) {
              res2.data.data.forEach(item => {
            item.collaborationUnit = item.payeeContractSubject
            item.payContractSubject = item.payeeContractSubject 
            item.payContractSubjectId = item.payeeContractSubjectId 
            item.contractUnit = item.customerUnit
            item.collectMoneyMouth = item.payeeYearMonth
            item.collectMoneyData = item.payeeTime
            item.collectMoney = item.payeeMoney
            item.remainMoney = item.payeeMoney
            item.paymentSource = "抵款"
          })
              this.offsetTableData = [...this.offsetTableData,...res2.data.data]
              this.offsetTotal = this.offsetTotal + res2.data.totalRows
              this.reChangeOffset();
              console.log( this.offsetTableData)
            }
          })
        }
      });
    },
    initOffset(){
      this.offsetParam={
        page: 1,
        pageSize: 10,
        collectMoneyMethodId: "333424134828724224",
        id:"",
        contractUnit:"",
      },
      this.getOffset();
    },
    handleSelectionChangeOff(rows){
      this.selectList = JSON.parse(JSON.stringify(rows));
      console.log(" ------------selectList ", this.selectList);
    },
    saveOffset(){
      this.selectList.forEach(item => {
        this.collectClaimList.push(item);
      });
      // this.collectClaimList = this.selectList
      console.log(" ------------collectClaimList ", this.collectClaimList);
      this.offsetDialog = false;
    },
    reChangeOffset() {
      let arr = [];
      this.offsetTableData.forEach(e => {
        // e.payContractSubject = e.collaborationUnit
        e.paymentSource = "抵款"
        e.collectMoneyId = e.id
        // e.remainMoney = e.collectMoney?e.collectMoney:0
        console.log("e.remainMoney_First"+e.remainMoney)
        let collectMoney = e.collectMoney*1
        // e.remainPay = this.numFormat(m.remainPay || 0);
        // alert("e.remainMoney1"+e.remainMoney)
        if (e.collectMoney) {
          e.collectMoney = this.numFormat(e.collectMoney || 0);
        }
        if (e.collectMoneyClaimList?.length > 0) {
          let length = e.collectMoneyClaimList.length;
          e.collectMoneyClaimList.forEach((m, n) => {
            if (m.claimMoney) {
              let claimMoney = Number(m.claimMoney)
              console.log("e.claimMoney_First"+m.claimMoney)
              console.log("claimMoney_typeof"+typeof(m.claimMoney))
              console.log("collectMoney_typeof"+typeof(collectMoney))
              console.log("e.remainMoney-m.claimMoney"+(collectMoney-claimMoney))
              // console.log()
              e.remainMoney = (collectMoney -(m.claimMoney*1?m.claimMoney*1:0) )
              collectMoney = e.remainMoney
              console.log("e.remainMoney_Second"+e.remainMoney)
              // alert("e.remainMoney2"+e.remainMoney)
              e.remainMoney =this.numFormat(e.remainMoney.toFixed(2) || 0);
              m.claimMoney = this.numFormat(m.claimMoney || 0);
            }
            m.payContractSubject = m.collaborationUnit
            m.id = e.id;
            if (n === 0) {
              arr.push({ ...e, ...m, rowspan: length, colspan: 1 });
            } else {
              arr.push({ ...e, ...m, rowspan: 0, colspan: 0 });
            }
          });
        } else {
          arr.push({ ...e, rowspan: 1, colspan: 1 });
        }
      });
      this.offsetTableData = arr;
      // this.$refs.table.doLayout()
    },
    addCardOffset() {
      // this.formDate = this.$options.data().formDate;
      // this.collectClaimList = [];
      this.titleName = "添加";
      this.offsetDialog = true;
      this.getOffset();
    },
    costMoneyInit() {
      this.dialog1 = true;
    },
    sallerSure() {
      // this.loadingSaller = true
      queryDefaultSallers().then(res => {
        if (res.code == 1001) {
          this.sallerList = res.data;
        }
      });
      setTimeout(() => {
        this.dialog3 = true;
        this.loadingSaller = false;
      });
    },
    lookcard(id) {
      this.titleName = "修改";
      console.log(id);
      var arr = this.tableDataCopy.filter(e => {
        if (e.id == id) return true;
      });
      console.log(arr);
      this.formDate = this.copy(arr[0]);
      if(this.formDate.paymentMethodId == "333424134828724224"){
        this.isAddOffset = true
      }else{
        this.isAddOffset = false
      }
      this.collectClaimList = this.formDate.list;
      this.dialog = true;
    },
    delHandler() {
      if (this.ids.length == 0) {
        this.$message({
          message: "请选择要操作的数据项",
          type: "warning",
        });
        return;
      }
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          post(this.batchUpdateOrDelete, this.ids).then(res => {
            if (res.code == 1001) {
              let page = Math.ceil((this.total - this.ids.length) / this.tableParam.pageSize);
              if (this.tableParam.page > Math.ceil(page / this.tableParam.pageSize)) {
                this.tableParam.page = page;
              }
              this.gettableDataex();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => {});
    },
    changstatus1(e, row) {
      console.log(e);
      console.log(row);
      if (row.paymentSource == "票据") {
        if (row.billNumber) {
          let data = [row.billNumber];
          selectByBillNumber(data).then(res => {
            this.collectClaimList[e] = { ...this.collectClaimList[e], ...res.data[0], paymentSource: "票据" };
            console.log(this.collectClaimList[e]);
            this.$set(this.collectClaimList, e, this.collectClaimList[e]);
          });
        }
      } else {
        row.billNumber = "";
        row.billNumberSelf = "";
        row.billSource = "";
        row.subjectCompany = "";
        row.billMoney = "";
        row.billTypeName = "";
        row.authBank = "";
        row.acceptor = "";
        row.drawer = "";
        row.receiver = "";
        row.issueDate = "";
        row.dueDate = "";
        this.$set(this.collectClaimList, e, row);
      }
    },
    changstatus2(e, row) {
      var chooseArr = this.supplierCategoryList.filter(m => {
        if (m.itemName == row.supplierType) {
          return true;
        }
      });
      this.collectClaimList[e].supplierTypeId = chooseArr[0].id;
      this.$set(this.collectClaimList, e, this.collectClaimList[e]);
    },
    changstatus3(e, row) {
      var chooseArr = this.supplierList.filter(m => {
        if (m.name == row.supplier) {
          return true;
        }
      });
      this.collectClaimList[e].supplierId = chooseArr[0].id;
      this.$set(this.collectClaimList, e, this.collectClaimList[e]);
    },
    changstatus4(e, row) {
      var chooseArr = this.mainList.filter(m => {
        if (m.name == row.payContractSubject) {
          return true;
        }
      });
      this.collectClaimList[e].payContractSubjectId = chooseArr[0].id;
      this.$set(this.collectClaimList, e, this.collectClaimList[e]);
    },
    changstatus5(e, row) {
      var chooseArr = this.shoukuanandmonList1.filter(m => {
        if (m.itemName == row.authBank) {
          return true;
        }
      });
      this.collectClaimList[e].authBankId = chooseArr[0].id;
      this.$set(this.collectClaimList, e, this.collectClaimList[e]);
    },
    addOtherSure() {
      console.log(this.collectClaimList);
      let data = {
        id: this.renlingId,
        collectMoneyClaimList: this.collectClaimList,
      };
      updateCollectMoneyClaim(data).then(res => {
        if (res.code == 1001) {
          this.gettableDataex();
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.dialog4 = false;
        }
      });
    },
    chooseNav(index) {
      this.currenindex = index;
    },
    open(low, key, disabled) {
      this.low = this.copy(low);
      this.disabled = disabled;
      this[key] = true;
    },
    reset(key) {
      this[key] = false;
    },
    submit(key) {
      this[key] = false;
      this.gettableDataex();
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam = { ...this.tableParam, paymentMethodId: "", supplier: "", startTime: "", endTime: "", billNumber: "", payContractSubject: "", authBank: "", paymentMoneyEnd: "", paymentMoneyStart: "",payContractSubjectNameList:[] };
      this.gettableDataex();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableDataex();
    },
    objectSpanMethod({ row, columnIndex }) {
      // console.log(column)
      // console.log(rowIndex)
      if (row.rowspan > 1) {
        if (
          columnIndex !== 5 &&
          columnIndex !== 6 &&
          columnIndex !== 7 &&
          columnIndex !== 8 &&
          columnIndex !== 9 &&
          columnIndex !== 6 &&
          columnIndex !== 10 &&
          columnIndex !== 11 &&
          columnIndex !== 12 &&
          columnIndex !== 13 &&
          columnIndex !== 14 &&
          columnIndex !== 15 &&
          columnIndex !== 16 &&
          columnIndex !== 17 &&
          columnIndex !== 18 &&
          columnIndex !== 19 &&
          columnIndex !== 20
        ) {
          return {
            rowspan: row.rowspan,
            colspan: row.colspan,
          };
        }
      } else {
        if (
          columnIndex !== 5 &&
          columnIndex !== 6 &&
          columnIndex !== 7 &&
          columnIndex !== 8 &&
          columnIndex !== 9 &&
          columnIndex !== 6 &&
          columnIndex !== 10 &&
          columnIndex !== 11 &&
          columnIndex !== 12 &&
          columnIndex !== 13 &&
          columnIndex !== 14 &&
          columnIndex !== 15 &&
          columnIndex !== 16 &&
          columnIndex !== 17 &&
          columnIndex !== 18 &&
          columnIndex !== 19 &&
          columnIndex !== 20
        ) {
          return {
            rowspan: row.rowspan,
            colspan: row.colspan,
          };
        }
      }
    },
  },
  watch: {
    collectClaimList: {
      handler() {
        this.formDate.paymentMoney = 0;
        this.collectClaimList.forEach(e => {
          if (e.currentPayMoney) {
            this.formDate.paymentMoney += Number(e.currentPayMoney);
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.tabtop {
  width: 381px;
}

.bill_title {
  font-size: 18px;
  font-weight: 600;
  padding: 15px 0;
}

.el-select-dropdown__list {
  width: 400px;
}

.boxSaller {
  display: flex;
  flex-wrap: wrap;
}

.sallerItem {
  // width: auto;
  height: 30px;
  background: #c4f0d9;
  // color: #fff;
  text-align: center;
  line-height: 30px;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 0 10px;
}

.search {
  display: flex;
  flex-wrap: wrap;
}
</style>
  